import React, { useState, useEffect, useCallback } from "react";
import { Box, Container, Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import { CasinoOutlined as LotteryIcon } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

// Web3 Contract Services
import cinstance from "../../../Service/randomcinstance";
import usercinstance from "../../../Service/usercinstance";
import web3 from "../../../Service/web3";
import { networkID } from "../../../../static/utils";
import { Path, getNetworkCurrency } from "../../../../static/Constants";
import Warnings from "../../../Components/Warning";
import Loaders from "../../../Components/Loaders";
import FailedPopup from "../../../Components/FailedPopup";
import SuccessPopup from "../../../Components/SuccessPopup";
import { colors, borderRadiusPx, customShadows } from "../../../../theme";

// Dashboard Layout & Shared UI Components
import { CreatorLayout } from "../../../Components/dashboard";
import { CommonButton } from "../../../Components/ui";

import CreateLotteryForm from "./CreateLotteryForm";
import "./CreateLottery.css";

const CreateLotteryPage = () => {
  const history = useHistory();

  // Form State
  const [entryfee, setentryfee] = useState("");
  const [totalnumber, settotalnumber] = useState("1");
  const [totalPrize, settotalPrize] = useState("");
  const [startTime, setstartTime] = useState(
    new Date(Date.now() + 8 * 24 * 60 * 60 * 1000)
  );
  const [endtime, setendtime] = useState(
    new Date(Date.now() + 20 * 24 * 60 * 60 * 1000)
  );
  const [drawdate, setdrawdate] = useState(
    new Date(Date.now() + 20 * 24 * 60 * 60 * 1000)
  );
  const [capacity, setcapacity] = useState("");
  const [lotteryCreateFee, setlotteryCreateFee] = useState("");
  const [minPlayers, setminPlayers] = useState("0");
  const [error, seterror] = useState(false);
  const [address, setAddress] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setloading] = useState(false);
  const [approved, setapproved] = useState({ active: true });
  const [lotterytype, setlotterytype] = useState("0");
  const [partnerlist, setPartnerlist] = useState([]);
  const [selectPartner, setSelectPartner] = useState("");
  const [Rollover, setRollover] = useState("");
  const [Rolloverday, setRolloverdays] = useState("");
  const [unlockCode, setUnlockCode] = useState("");
  const [showFail, setShowFail] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [partnerPercent, setPartnerPercent] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState(() =>
    getNetworkCurrency(networkID)
  );

  const getList = useCallback(async () => {
    try {
      if (!cinstance?.methods?.partnerId) return;
      const res = await cinstance.methods.partnerId().call();
      const count = Number(res);
      const partnerlists = [];

      for (let i = 0; i <= count; i++) {
        try {
          const responseAdd = await cinstance.methods.partnerids(i).call();
          if (
            responseAdd &&
            responseAdd !== "0x0000000000000000000000000000000000000000"
          ) {
            const response = await cinstance.methods
              .partnerbyaddr(responseAdd)
              .call();
            if (
              response &&
              response.partnerAddress !==
                "0x0000000000000000000000000000000000000000"
            ) {
              partnerlists.push(response);
            }
          }
        } catch (err) {
          console.warn("Failed fetching partner item at index", i, err);
        }
      }

      setPartnerlist(partnerlists);
    } catch (err) {
      console.warn("Error fetching partner list:", err);
    }
  }, []);

  const onSendmsg = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);

    let val = true;

    if (Number(entryfee) >= Number(totalPrize)) {
      val = false;
    }
    if (Number(entryfee) < 0 || entryfee === "") {
      val = false;
    }
    if (Number(totalPrize) <= 0 || totalPrize === "") {
      val = false;
    }
    if (lotterytype !== "3") {
      if (Number(totalnumber) > Number(capacity)) {
        val = false;
      }
      if (Number(totalnumber) < 1) {
        val = false;
      }
      if (
        (lotterytype === "0" || lotterytype === "2") &&
        Number(capacity) < 5
      ) {
        val = false;
      }
      if (lotterytype === "1" && Number(capacity) < 3) {
        val = false;
      }
    }
    if (partnerlist.length > 0 && selectPartner === "") {
      val = false;
      toast.warn("Please select a partner co-host.");
    }
    if (
      (unlockCode < 1 || unlockCode > 10 || unlockCode === "") &&
      lotterytype === "3"
    ) {
      val = false;
    }
    if (
      parseFloat(Rolloverday) < 1 &&
      (lotterytype === "2" || lotterytype === "3")
    ) {
      val = false;
    }

    if (!val) {
      return;
    }

    let days = Rolloverday;
    const currentDT = moment().unix();
    const st = moment(startTime).unix();
    const et = moment(endtime).unix();
    const dt = moment(drawdate).unix();

    if (Rolloverday === "" && lotterytype !== "2" && lotterytype !== "3") {
      days = 0;
    } else {
      days = Number(Number(Rolloverday) * 86400).toFixed();
    }

    if (currentDT > st || currentDT > et || currentDT > dt) {
      toast.error("Datetime cannot be before the current date and time!");
      return;
    }

    const rolloverValue = Number(Rollover || 0);
    if (rolloverValue > 50) {
      toast.error("Rollover value cannot exceed 50%");
      return;
    }

    if (st >= et && (lotterytype === "2" || lotterytype === "3")) {
      toast.error("Rollover/Result time must be greater than start time!");
      return;
    }

    try {
      setloading(true);
      const entryfee1 = web3.utils.toWei(`${entryfee}`, "ether");
      const totalPrize1 = web3.utils.toWei(`${totalPrize}`, "ether");
      const feePercent = Number(lotteryCreateFee || 0);
      const tl =
        (Number(totalPrize1) * feePercent) / 100 + Number(totalPrize1);
      const lotterytype1 = Number(lotterytype);

      const accounts = await web3.eth.getAccounts();
      if (!accounts || accounts.length === 0) {
        toast.error("No Web3 account found. Please connect your wallet.");
        setloading(false);
        return;
      }

      await cinstance.methods
        .createLottery(
          entryfee1,
          totalnumber,
          totalPrize1,
          st,
          et,
          dt,
          capacity || "0",
          rolloverValue,
          days,
          partnerPercent || "0",
          selectPartner || "0x0000000000000000000000000000000000000000",
          lotterytype1
        )
        .send({ from: accounts[0], value: tl.toString() });

      setloading(false);
      setShowSuccess(true);
    } catch (err) {
      console.error("Create lottery transaction failed:", err);
      setloading(false);
      setShowFail(true);
    }
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      if (window.ethereum) {
        window.web3 = web3;
        try {
          if (web3?.eth?.net?.getId) {
            try {
              const netId = await web3.eth.net.getId();
              if (isMounted) {
                setCurrencySymbol(getNetworkCurrency(netId));
              }
            } catch (netErr) {
              console.warn("Network ID check skipped:", netErr);
            }
          }

          const accounts = await web3.eth.getAccounts();
          if (accounts && accounts.length !== 0) {
            if (isMounted) setAddress(accounts[0]);

            usercinstance.methods
              .organisationbyaddr(accounts[0])
              .call()
              .then((res) => {
                if (isMounted && res) {
                  setapproved(res);
                }
              })
              .catch((err) => console.warn("Organisation check error:", err));

            cinstance.methods
              .lotteryCreateFee()
              .call()
              .then((res) => {
                if (isMounted) {
                  setlotteryCreateFee(res);
                }
              })
              .catch((err) => console.warn("LotteryCreateFee error:", err));
          } else {
            if (isMounted) seterror(false);
          }
        } catch (e) {
          console.warn("Wallet access error:", e);
        }
      }
    }

    fetchData();
    getList();

    const handleAccountsChanged = () => {
      window.location.reload();
    };

    if (window.ethereum?.on) {
      window.ethereum.on("accountsChanged", handleAccountsChanged);
    }

    return () => {
      isMounted = false;
      if (window.ethereum?.removeListener) {
        window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
      }
    };
  }, [getList]);

  return (
    <CreatorLayout
      title="Create A New Lottery"
      subtitle="Configure rules, prize pool, and deploy decentralized smart contract game"
      breadcrumbs={[
        { label: "Dashboard", href: Path.org },
        { label: "Create Lottery" },
      ]}
      headerActions={
        <CommonButton
          variant="outlined"
          onClick={() => history.push(Path.orgmylottery)}
          startIcon={<LotteryIcon />}
        >
          My Lotteries
        </CommonButton>
      }
      creatorAddress={address}
      userName={approved?.name || "Creator"}
      authChecked={!loading}
      isAuthorized={approved?.active}
      accessDeniedProps={{
        title: "Account Access Denied",
        message: "You must be a registered Creator or organization to view Create Lottery.",
        actionText: "Register as Organisation",
        actionPath: Path.registerasorg,
      }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      {error && <Warnings />}
      {loading && <Loaders />}

      <Box sx={{ maxWidth: { xs: "100%", md: "840px", lg: "880px" } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, sm: 3.5 },
            borderRadius: borderRadiusPx.xl,
            border: `1px solid ${colors.dashboard.cardBorder}`,
            bgcolor: colors.background.paper,
            boxShadow: customShadows.cardFlat,
          }}
        >
          <CreateLotteryForm
            lotterytype={lotterytype}
            setlotterytype={setlotterytype}
            partnerlist={partnerlist}
            selectPartner={selectPartner}
            setSelectPartner={setSelectPartner}
            entryfee={entryfee}
            setentryfee={setentryfee}
            totalPrize={totalPrize}
            settotalPrize={settotalPrize}
            totalnumber={totalnumber}
            settotalnumber={settotalnumber}
            capacity={capacity}
            setcapacity={setcapacity}
            unlockCode={unlockCode}
            setUnlockCode={setUnlockCode}
            startTime={startTime}
            setstartTime={setstartTime}
            endtime={endtime}
            setendtime={setendtime}
            setdrawdate={setdrawdate}
            Rollover={Rollover}
            setRollover={setRollover}
            Rolloverday={Rolloverday}
            setRolloverdays={setRolloverdays}
            partnerPercent={partnerPercent}
            setPartnerPercent={setPartnerPercent}
            minPlayers={minPlayers}
            setminPlayers={setminPlayers}
            lotteryCreateFee={lotteryCreateFee}
            approved={approved}
            validated={validated}
            loading={loading}
            currencySymbol={currencySymbol}
            onSubmit={onSendmsg}
          />
        </Paper>
      </Box>

      {/* Transaction Modal Popups */}
      <SuccessPopup
        show={showSuccess}
        setShowModal={(e) => setShowSuccess(e)}
        message="Lottery created successfully!"
        redirectPath={Path.orgmylottery}
        btnName="Go to my lottery"
      />
      <FailedPopup show={showFail} setShowModal={(e) => setShowFail(e)} />
    </CreatorLayout>
  );
};

export default CreateLotteryPage;
